
<template>
  <v-container>
      <v-card class="pa-4">
        <v-card-text class="mt-3 title font-italic" style="color:var(--v-primary-base);">
          {{ $t('userMessage.wip-title') }}
        </v-card-text>
        <v-tooltip open-delay="800ms" bottom color="rgba(var(--suspendMedia-rgb),1)">
          <template v-slot:activator="{ on }">
            <img class="mb-2" style="height:274px;width:274px;" src="@/assets/images/illu_wip_2.png" v-on="on">
          </template>
          <span>Illustration : Ivan Haidutski</span>
        </v-tooltip>
        <v-card-text class="body-2" style="color:var(--v-primary-base);">
          {{ $t('userMessage.wip-message') }}
        </v-card-text>
<!--         <v-card-text class="font-weight-medium" style="color:var(--v-primary-base);"><v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
          {{ $t('userMessage.media-delete-warning') }}
        </v-card-text> -->
        <v-card-actions class="justify-center">
          <v-btn large text rounded style="width:45%" class="custom-valid-btn suspend-media" @click="closeDialog">{{ $t('global.close')}}</v-btn>
        </v-card-actions>
      </v-card>
  </v-container>
</template>

<script>
export default {
  methods: {
    closeDialog () {
      this.$parent.$parent.$parent.closeWIPDialog()
    }
  }
}
</script>

<style scoped>
</style>
